package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class ExperienceState(
    val id: String,
    poste: String = "",
    employeur: String = "",
    ville: String = "",
    moisDebut: String = "",
    anneeDebut: String = "",
    moisFin: String = "",
    anneeFin: String = "",
    isOngoing: Boolean = false,
    description: String = ""
) {
    var poste by mutableStateOf(poste)
    var employeur by mutableStateOf(employeur)
    var ville by mutableStateOf(ville)
    var moisDebut by mutableStateOf(moisDebut)
    var moisFin by mutableStateOf(moisFin)
    var anneeDebut by mutableStateOf(anneeDebut)
    var anneeFin by mutableStateOf(anneeFin)
    var isOngoing by mutableStateOf(isOngoing)
    var description by mutableStateOf(description)
}
